<template>
  <v-container v-if="$auth.check()">
    <v-row>
      <v-col>
        <h1>{{ $t('texts.employee.label') }}</h1>
      </v-col>
    </v-row>
    <v-alert type="warning" :value="!hasActiveSubscription">
      {{ $t('texts.alert.subscriptionRequired.updateEmployee') }}
      <v-btn
        :to="{ name: 'subscription.admin' }"
        outlined
        color="white"
        small
      >
        {{ $t('texts.subscriptionInformation') }}
      </v-btn>
    </v-alert>
    <v-row>
      <v-col :cols="12">
        <v-card>
          <v-tabs
            v-model="active"
            slider-color="primary"
            color="transparent"
            active-class="text--primary"
            :show-arrows="$vuetify.breakpoint.smAndDown"
          >
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/employees/assignment` }"
            >
              {{ $t('texts.confirm') }}
            </v-tab>
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/employees/all` }"
            >
              {{ $t('texts.all') }}
            </v-tab>
            <v-tab
              ripple
              @click="filter = 'CURRENT'"
              :to="{ path: `/company/${company.id}/employees/current` }"
            >
              {{ $t('texts.employee.employed') }}
            </v-tab>
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/employees/future` }"
            >
              {{ $t('texts.employee.future') }}
            </v-tab>
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/employees/past` }"
            >
              {{ $t('texts.employee.former') }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="active">
            <router-view/>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');

export default {
  name: 'CompanyEmployees',
  data() {
    return {
      active: null,
    };
  },
  computed: {
    ...mapCompanyProfileState([
      'company',
    ]),
    hasActiveSubscription() {
      return this.company.active_subscription;
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-tabs__item--active {
      color: #0d5890;
    }
  }
</style>
